export const LAST_SOLD_OUT_ANNUAL_REPORTS_YEAR = 2022
